import React, { useState } from 'react';
import profile from "../../assets/profile_image.jpg";
import notify from "../../assets/notification.png";
import JournalReport from '../../pages/reports/JournalReport';
import { FaPowerOff } from "react-icons/fa6";
import { Modal, Button } from 'react-bootstrap';
const Profile = () => {
  const [activeComponent, setActiveComponent] = useState('journal');
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const currentPage = window.location.pathname;

  const renderButton = () => {
    switch (currentPage) {
      case '/dashboard':
        return <button className='btn'>Dashboard</button>;
      case '/report':
        return <>
          <button className={activeComponent === 'journal' ? "btn" : "btn active"} onClick={() => handleButtonClick('journal')}>Journal</button>
          <button className={activeComponent === 'journal' ? "btn active" : "btn"} onClick={() => handleButtonClick('report')}>Reports</button>
        </>
      case '/customers':
        return <button className='btn'>Account</button>;
      case '/customer-transactions':
        return <button className='btn'>Account</button>;
      case '/users':
        return <button className='btn'>Users</button>;
      case '/settings':
        return <button className='btn'>Settings</button>;
      default:
        return <button className='btn'>Companies</button>;
    }
  };

  const fnLogout = () => {
    localStorage.removeItem('accessToken');
    setTimeout(() => {
      window.location.href = "/";
    }, 2000);
  };

  const handleButtonClick = (component) => {
    setActiveComponent(component);
  };

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleConfirmLogout = () => {
    setShowLogoutModal(false);
    fnLogout();
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  return (
    <>
      <div className='profile-sc d-flex justify-content-between align-items-center'>
        <div className='profile-sc__left'>
          {renderButton()}
        </div>
        <div className='profile-sc__right'>
          <FaPowerOff onClick={handleLogoutClick} />
          <span className="tooltiptext">Logout</span>
        </div>
      </div>
      {currentPage === '/report' && <JournalReport activeComponent={activeComponent} />}

      <Modal show={showLogoutModal} onHide={handleCancelLogout}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to logout?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelLogout}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmLogout}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Profile;